import type { OrderForm } from 'src/sdk/checkout/entity/orderForm'

export function findCustomApp(appId: string, orderForm: OrderForm) {
  return orderForm.customData?.customApps?.find((app) => app.id === appId)
}
